/**
 * "Interface" for a FINDOLOGIC interaction tracker. Don't use it directly, but get a working implementation by
 * invoking FindologicTracker.getInstance() instead.
 *
 * @param {{}} config
 * @param {string} config.shopkey
 * @param {{}} config.directIntegration
 * @param {string} config.directIntegration.frontend
 * @constructor
 */
export default function FindologicTracker(config) {
    this.trackingUrl = config.directIntegration.frontend + 'tracking.php?shopkey=' + config.shopkey;

    /**
     * Tracks a result click.
     *
     * @param {string} requestId
     * @param {string} productId
     * @param {string} productName
     * @param {int} resultIndex
     * @param {string} query
     * @param {string} type (like search/navigation)
     * @param {function} [callback] Called once the interaction has been tracked, tracking failed, or timed out.
     *      It can be assumed that this function is called always. No arguments are passed.
     */
    this.trackResultClick = function (requestId, productId, productName, resultIndex, query, type, callback) {
        this.send(
            this.trackingUrl,
            JSON.stringify({
                serviceId: config.shopkey,
                interaction: type + '.result.click',
                requestId: requestId,
                resultIndex: resultIndex,
                productId: String(productId),
                productName: productName,
                query: query,
                timestamp: Date.now(),
            }),
            callback
        );
    };

    // noinspection JSUnusedLocalSymbols (arguments used in descending prototypes)
    /**
     * Implementation-specific method to send the data to track to a certain URL.
     *
     * @param {string} url The URL to send the data to.
     * @param {string} data The tracking data to send.
     * @param {function} callback The callback to execute once tracking is complete.
     */
    /* eslint-disable no-unused-vars */
    this.send = function (url, data, callback) {
        throw new Error('Method must be implemented by a specific FINDOLOGIC tracking implementation.');
    };
    /* eslint-enable no-unused-vars */
}

/**
 * @type {number} Time in milliseconds before considering a slow tracking request lost. This is the latest point in
 *      time at which the callback can be invoked.
 */
FindologicTracker.TIMEOUT = 1000;
